import React from 'react';
import { observer } from 'mobx-react-lite';

import './style.sass';

import { useModel } from 'app/hooks/useViewModel';
import { Page } from 'app/components/common/PageLayout';
import { ResetPasswordForm } from 'app/components/ResetPasswordForm';
import { ResetPasswordModes, ResetPasswordPageViewModel } from 'app/viewModels/pages/ResetPasswordPageViewModel';


export const ResetPasswordPage = observer(() => {
    const {
        submitForm,
        isLoading,
        mode,
    } = useModel(ResetPasswordPageViewModel);

    const isEmailMode = mode === ResetPasswordModes.Email;

    return (
        <Page className="reset-password-page" isLoading={isLoading}>
            <div className="text-block">
                <h1 className="reset-password-page__title title-h1 dark-violet">Reset password</h1>
                <p className="reset-password-page__desc p2-medium grey-1">
                    {isEmailMode
                        ? 'Please enter the email of your account and we will send you an email with the link to reset your password'
                        : 'Please enter and confirm your new password'
                    }
                </p>
            </div>

            <ResetPasswordForm
                isEmailMode={isEmailMode}
                onSubmit={submitForm}
            />
        </Page>
    );
});
